import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import TeamAssistMessage from 'models/team_assist_message';

export default class RetryAskTeamAssist {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId }) {
    if (!customerId || !messageId) {
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const { teamAssists } = this.context.stores.customers.storesFor(customerId);
    const message = teamAssists.find(messageId);
    if (!message) {
      return;
    }

    teamAssists.addOrReplace(TeamAssistMessage.fromJs({ ...message.toJs(), error: false }));
    teamAssists.setLoading();

    const body = { id: messageId, question: message.content };
    if (message.displayedMessage) {
      body.displayedMessage = message.displayedMessage;
    }

    this.context.gateways.teamAssist
      .add({ customerId }, body)
      .catch(err => {
        const msg = teamAssists.find(messageId);
        if (msg) {
          teamAssists.addOrReplace(TeamAssistMessage.fromJs({ ...msg.toJs(), error: true }));
        }
        handleCommonErrors(this.context, err);
      })
      .finally(() => {
        teamAssists.resetLoading();
      });
  }
}
